import { Scene } from 'phaser';
import { BotaoArcade } from '../components/BotaoArcade';
import { desenharPaginaLima } from '../components/cenario';
import { ModalArcade } from '../components/ModalArcade';
import { alturaDoPlacar, desenharPlacar } from '../components/Placar';
import { criarTextoRico } from '../components/TextoRico';
import { SCENES, TEX } from '../config/constants';
import { ARCADE_HEX, ARCADE_TEXT } from '../config/theme';
import { montarPlacaresLab, ProgressoLabPixels, roteiro } from '../services/labPixels';
import { Sessao } from '../services/Sessao';
import { t } from '../services/textos';

const PARAGRAFOS = ['lab.resultado_texto_1', 'lab.resultado_texto_2', 'lab.resultado_texto_3'];

/** Laboratório de Pixels — resultados e finalização (Figma, quadros 72 e 73). */
export class LabPixelsResultadoScene extends Scene {
    constructor () {
        super(SCENES.LAB_RESULTADO);
    }

    async create () {
        if (!Sessao.ativa) {
            this.scene.start(SCENES.LOGIN);
            return;
        }
        const fonte = this.registry.get('fonte');
        const progresso = new ProgressoLabPixels(Sessao.atual.participanteId);

        desenharPaginaLima(this, {
            titulo: t('lab.titulo'), rotuloJogador: Sessao.rotulo, rotuloY: 128, espacamento: 0
        });
        this.add.image(64, 48, TEX.BTN_INSIGHTS_REDONDO).setOrigin(0)
            .setInteractive({ useHandCursor: true })
            .on('pointerup', () => !this.modal && this.scene.start(SCENES.AGUARDE, {}));

        this.add.text(64, 201, t('lab.resultado_manchete'), ARCADE_TEXT.manchete).setOrigin(0, 0.5);
        this.add.rectangle(64, 238, 631, 1, ARCADE_HEX.TINTA).setOrigin(0, 0.5);
        let y = 266;
        PARAGRAFOS.map((chave) => t(chave)).forEach((paragrafo) => {
            y += criarTextoRico(this, 64, y, 612, paragrafo, ARCADE_TEXT.introducao, { entrelinha: 29 }).altura + 27;
        });

        new BotaoArcade(this, 640, 711, { rotulo: t('geral.continuar'), aoClicar: () => this.abrirFinalizacao() });   // RI-LAB-09

        let comuns = [];
        try {
            ({ comuns } = roteiro(await fonte.obterCatalogoLabPixels()));
        } catch (falha) {
            console.error('[LabPixels] catálogo indisponível para montar o placar.', falha);
        }
        if (!this.scene.isActive()) return;

        const { estado } = progresso;
        // Dois cards, um embaixo do outro: o individual (perguntas) e o do grupo (a bônus).
        const { individual, grupo } = montarPlacaresLab({
            comuns,
            respostas: estado.respostas,
            bonus: { liberado: estado.bonus.liberado, correta: progresso.bonusCorreta }
        });
        desenharPlacar(this, 853, 182, individual);
        desenharPlacar(this, 853, 182 + alturaDoPlacar(individual) + 18, grupo);

        // Envio que ficou pendente na fase é refeito aqui, com a mesma chave.
        if (!estado.enviado) {
            try {
                await fonte.enviarResultadoLabPixels(progresso.envio());
                progresso.marcarEnviado();
            } catch (falha) {
                console.error('[LabPixels] resultado segue pendente.', falha);
            }
        }
    }

    abrirFinalizacao () {
        if (this.modal) return;
        this.modal = new ModalArcade(this, {
            titulo: t('lab.titulo'),
            largura: 780,
            blocos: [
                { texto: t('lab.fim_titulo'), peso: '600', maiusculas: true },
                { texto: t('lab.fim_texto_1') },
                { texto: t('lab.fim_texto_2') },
                { texto: t('lab.fim_texto_3') }
            ],
            // Em produção quem devolve o grupo ao Aguarde é o facilitador (`aoEstacao` em `ligarEstacaoDoGrupo`);
            // o botão só existe no modo dev, que não tem facilitador.
            ...(this.registry.get('fonte')?.modo === 'dev' ? {
                botao: {
                    rotulo: t('geral.concluir'), largura: 324,
                    aoClicar: () => this.scene.start(SCENES.AGUARDE, { concluida: 'labpixels' })
                }
            } : {}),
            voltar: { rotulo: t('geral.voltar_pontuacao') },
            aoFechar: () => { this.modal = null; }
        });
    }
}
